/**
 * FontStle.ts
 */
export class FontStyle {
}
FontStyle.DEFAULT = "FontStyle.DEFAULT";
FontStyle.TEST_BUTTON = "FontStyle.TEST_BUTTON";
FontStyle.TICKET_SYMBOL = "FontStyle.TICKET_SYMBOL";
FontStyle.REEL_SYMBOL = "FontStyle.REEL_SYMBOL";
FontStyle.REEL_SYMBOL_HELP = "FontStyle.REEL_SYMBOL_HELP";
FontStyle.SCATTER_WIN_COUNTER = "FontStyle.SCATTER_WIN_COUNTER";
FontStyle.TOTAL_WIN_COUNTER = "FontStyle.TOTAL_WIN_COUNTER";
FontStyle.PURCHASE_SPIN_BUTTON = "FontStyle.PURCHASE_SPIN_BUTTON";
FontStyle.START_GAME_BUTTON = "FontStyle.START_GAME_BUTTON";
FontStyle.SPIN_PRICE = "FontStyle.SPIN_PRICE";
FontStyle.COLLECT_BUTTON = "FontStyle.COLLECT_BUTTON";
FontStyle.END_GAME_BUTTON = "FontStyle.END_GAME_BUTTON";
FontStyle.SPIN_BUTTON = "FontStyle.SPIN_BUTTON";
FontStyle.FREE_SPIN_BUTTON = "FontStyle.FREE_SPIN_BUTTON";
FontStyle.BIG_WIN = "FontStyle.BIG_WIN";
FontStyle.FULL_HOUSE = "FontStyle.FULL_HOUSE";
FontStyle.BIG_WIN_ANIMATION_TITLE = "GameFontStyle.BIG_WIN_ANIMATION_TITLE";
FontStyle.BIG_WIN_ANIMATION_COUNTER = "GameFontStyle.BIG_WIN_ANIMATION_COUNTER";
FontStyle.FULL_HOUSE_ANIMATION_TITLE = "GameFontStyle.FULL_HOUSE_ANIMATION_TITLE";
FontStyle.FULL_HOUSE_ANIMATION_COUNTER = "GameFontStyle.FULL_HOUSE_ANIMATION_COUNTER";
FontStyle.SCATTER_WIN_ANIMATION_TITLE = "GameFontStyle.SCATTER_WIN_ANIMATION_TITLE";
FontStyle.SCATTER_WIN_ANIMATION_COUNTER = "GameFontStyle.SCATTER_WIN_ANIMATION_COUNTER";
FontStyle.PAY_TABLE_CELL_NO_WIN = "FontStyle.PAY_TABLE_CELL_NO_WIN";
FontStyle.PAY_TABLE_CELL = "FontStyle.PAY_TABLE_CELL";
FontStyle.PAY_TABLE_SCATTER = "FontStyle.PAY_TABLE_SCATTER";
FontStyle.PAY_TABLE_BUTTON = "FontStyle.PAY_TABLE_BUTTON";
FontStyle.MESSAGE_BAR = "FontStyle.MESSAGE_BAR";
FontStyle.BALANCE = "FontStyle.BALANCE";
FontStyle.CLOCK = "FontStyle.CLOCK";
FontStyle.STANDARD_SPINS_REMAINING = "FontStyle.STANDARD_SPINS_REMAINING";
FontStyle.PURCHASE_SPINS_REMAINING = "FontStyle.PURCHASE_SPINS_REMAINING";
FontStyle.GAME_SUMMARY_CELL = "FontStyle.GAME_SUMMARY_CELL";
FontStyle.GAME_SUMMARY_TITLE = "FontStyle.GAME_SUMMARY_TITLE";
FontStyle.GAME_SUMMARY_WIN = "FontStyle.GAME_SUMMARY_WIN";
FontStyle.GAME_OVER = "FontStyle.GAME_OVER";
FontStyle.FREE_SPIN_SYMBOL = "FontStyle.FREE_SPIN_SYMBOL";
FontStyle.BOTTOM_BAR = "FontStyle.BOTTOM_BAR";
FontStyle.TICKET_SYMBOL_DAB_HIGHLIGHT = "FontStyle.TICKET_SYMBOL_DAB_HIGHLIGHT";
FontStyle.TICKET_SYMBOL_WIN_HIGHLIGHT = "FontStyle.TICKET_SYMBOL_WIN_HIGHLIGHT";
FontStyle.SLINGO_2_ANIMATION = "FontStyle.SLINGO_2_ANIMATION";
FontStyle.SLINGO_3_ANIMATION = "FontStyle.SLINGO_3_ANIMATION";
FontStyle.SLINGO_4_ANIMATION = "FontStyle.SLINGO_4_ANIMATION";
FontStyle.LOADER_LEGAL = "FontStyle.LOADER_LEGAL";
//# sourceMappingURL=FontStyle.js.map